/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lower: NonNullable<unknown>, upper: NonNullable<unknown> }} Body_Assessment_Whtr_Near_ThresholdInputs */

const en_us2_body_assessment_whtr_near_threshold = /** @type {(inputs: Body_Assessment_Whtr_Near_ThresholdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You're right on the boundary between ${i?.lower} and ${i?.upper}, so read this as a direction rather than a verdict.`)
};

const pt_br2_body_assessment_whtr_near_threshold = /** @type {(inputs: Body_Assessment_Whtr_Near_ThresholdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você está bem na fronteira entre ${i?.lower} e ${i?.upper}, então leia isso como uma direção, não como um veredito.`)
};

const es_419_body_assessment_whtr_near_threshold = /** @type {(inputs: Body_Assessment_Whtr_Near_ThresholdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estás justo en el límite entre ${i?.lower} y ${i?.upper}, así que léelo como una dirección y no como un veredicto.`)
};

const pt_pt2_body_assessment_whtr_near_threshold = /** @type {(inputs: Body_Assessment_Whtr_Near_ThresholdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estás mesmo na fronteira entre ${i?.lower} e ${i?.upper}, por isso lê isto como uma direção, não como um veredicto.`)
};

const fr_fr2_body_assessment_whtr_near_threshold = /** @type {(inputs: Body_Assessment_Whtr_Near_ThresholdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu es pile à la limite entre ${i?.lower} et ${i?.upper}, alors lis ceci comme une tendance plutôt qu'un verdict.`)
};

const de_de2_body_assessment_whtr_near_threshold = /** @type {(inputs: Body_Assessment_Whtr_Near_ThresholdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du liegst genau an der Grenze zwischen ${i?.lower} und ${i?.upper}, lies das also als Richtung, nicht als Urteil.`)
};

const it_it2_body_assessment_whtr_near_threshold = /** @type {(inputs: Body_Assessment_Whtr_Near_ThresholdInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sei proprio al confine tra ${i?.lower} e ${i?.upper}, quindi leggilo come una direzione e non come un verdetto.`)
};

/**
* | output |
* | --- |
* | "You're right on the boundary between {lower} and {upper}, so read this as a direction rather than a verdict." |
*
* @param {Body_Assessment_Whtr_Near_ThresholdInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_whtr_near_threshold = /** @type {((inputs: Body_Assessment_Whtr_Near_ThresholdInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Whtr_Near_ThresholdInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_whtr_near_threshold(inputs)
	if (locale === "es-419") return es_419_body_assessment_whtr_near_threshold(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_whtr_near_threshold(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_whtr_near_threshold(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_whtr_near_threshold(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_whtr_near_threshold(inputs)
	return en_us2_body_assessment_whtr_near_threshold(inputs)
});
export { body_assessment_whtr_near_threshold as "body-assessment.whtr_near_threshold" }